export const EMPTY = {
  tag: 'EMPTY',
};

export const ACCESS_LOGIN = {
  tag: 'ACCESS_LOGIN',
};

export const ASK_PLANS = {
  tag: 'ASK_PLANS',
};

export const ASK_PLANS_WITH_ACCESS_LOGIN = {
  tag: 'ASK_PLANS_WITH_ACCESS_LOGIN',
};

export const ASK_CONFIRMATION = {
  tag: 'ASK_CONFIRMATION',
};
